module.exports = __webpack_public_path__ + "officialStatic/img/product-item-bg.6ebb233.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-item-bg.png
// module id = ODJr
// module chunks = 0